import path from 'node:path';
import { randomUUID } from 'node:crypto';
import type {
  EmbedCategory,
  EmbeddedScriptPlacement,
} from '@wix/ambassador-devcenter-apps-v1-app-old/types';
import { componentGenerator } from '@wix/gena';
import { toJsonString } from '@wix/cli-fs';
import { getEmbeddedScriptsDir } from '@wix/cli-app-definitions';
import type { EmbeddedScriptConfig } from '@wix/cli-app-definitions';

const EMBEDDED_SCRIPT_TEMPLATE = path.resolve(
  __dirname,
  '../templates/embedded-script'
);

export async function generateEmbeddedScript(
  projectFolder: string,
  folder: string,
  name: string,
  scriptType:
    | EmbedCategory.ESSENTIAL
    | EmbedCategory.FUNCTIONAL
    | EmbedCategory.ANALYTICS
    | EmbedCategory.ADVERTISING,
  placement:
    | EmbeddedScriptPlacement.HEAD
    | EmbeddedScriptPlacement.BODY_START
    | EmbeddedScriptPlacement.BODY_END
) {
  const cwd = path.join(getEmbeddedScriptsDir(projectFolder), folder);

  const embeddedScriptConfig: EmbeddedScriptConfig = {
    $schema: 'https://dev.wix.com/wix-cli/schemas/embedded-script.json',
    id: randomUUID(),
    name,
    scriptType,
    placement,
  };
  const embeddedScriptConfigJSON = toJsonString(embeddedScriptConfig, {
    spaces: 2,
  });

  return await componentGenerator({
    template: EMBEDDED_SCRIPT_TEMPLATE,
    projectFolder,
    cwd,
    data: {
      embeddedScriptConfigJSON,
      name,
      scriptType,
      placement,
    },
  });
}
